<main class="mediumContainer">
    <mat-card>
        <mat-card-header>
            <mat-card-subtitle>
                <h3>Reports</h3>
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content [formGroup]="form">
            <app-custom-toggle-group [options]="modeOptions" formControlName="mode"></app-custom-toggle-group>
            @if (selectedManageMode === managementMode.Generate || selectedManageMode === managementMode.BI) {
                <mat-form-field class="w-100" color="accent">
                    <mat-label>Report type</mat-label>
                    <mat-select [formControl]="reportType">
                        @for (type of reportTypes; track type) {
                            <mat-option [value]="type.type">{{ type.label }}</mat-option>
                        }
                    </mat-select>
                    @if (reportType.hasError('required')) {
                        <mat-error>
                            This field is required
                        </mat-error>
                    }
                </mat-form-field>
                @if (reportControlIds.includes('communityId')) {
                    <mat-form-field class="w-100" color="accent">
                        <mat-label>Community</mat-label>
                        <mat-select formControlName="communityId">
                            @if (selectedManageMode === managementMode.Generate) {
                                <mat-option value="">All</mat-option>
                            }
                            @for (community of communities; track community) {
                                <mat-option [value]="community.id">{{ community.name }}
                                </mat-option>
                            }
                        </mat-select>
                        @if (form.controls['communityId'].hasError('required')) {
                            <mat-error>
                                This field is required
                            </mat-error>
                        }
                    </mat-form-field>
                }
                @if (reportControlIds.includes('subgroupId')) {
                    <mat-form-field class="w-100" color="accent">
                        <mat-label>Subgroup</mat-label>
                        <mat-select formControlName="subgroupId">
                            @if (!subgroups.length && selectedCommunityId) {
                                <mat-option disabled value="">Current community
                                    has no subgroups
                                </mat-option>
                            }
                            @if (!!subgroups.length) {
                                <mat-option value="">All</mat-option>
                            }
                            @for (subgroup of subgroups; track subgroup) {
                                <mat-option [value]="subgroup.id">{{ subgroup.name }}
                                </mat-option>
                            }
                        </mat-select>
                        @if (form.controls['subgroupId'].hasError('required')) {
                            <mat-error>
                                This field is required
                            </mat-error>
                        }
                    </mat-form-field>
                }
                @if (reportControlIds.includes('postId')) {
                    <mat-form-field class="w-100 mb-15" color="accent">
                        <mat-label>Post</mat-label>
                        <mat-select formControlName="postId">
                            @if (!posts.length && selectedCommunityId) {
                                <mat-option disabled value="">Current community has
                                    no posts
                                </mat-option>
                            }
                            @if (!!posts.length) {
                                <mat-option value="">All</mat-option>
                            }
                            @for (post of posts; track post) {
                                <mat-option [value]="post.id">[ID:{{ post.id }}] - {{ post.title }}
                                </mat-option>
                            }
                        </mat-select>
                        @if (form.controls['postId'].hasError('required')) {
                            <mat-error>
                                This field is required
                            </mat-error>
                        }
                        <mat-hint>Reports for individual posts are limited to the last 200</mat-hint>
                    </mat-form-field>
                }
                @if (reportControlIds.includes('memberId')) {
                    <mat-form-field class="w-100 mb-15" color="accent">
                        <mat-label>Member</mat-label>
                        <mat-select formControlName="memberId">
                            @if (!users.length && selectedCommunityId) {
                                <mat-option disabled value="">Current community has
                                    no members
                                </mat-option>
                            }
                            @if (!!users.length) {
                                <mat-option value="">All</mat-option>
                            }
                            @for (user of users; track user) {
                                <mat-option [value]="user.id">{{ userName(user) }}</mat-option>
                            }
                        </mat-select>
                        @if (form.controls['memberId'].hasError('required')) {
                            <mat-error>
                                This field is required
                            </mat-error>
                        }
                    </mat-form-field>
                }
                @if (reportControlIds.includes('pollId')) {
                    <mat-form-field class="w-100 mb-15" color="accent">
                        <mat-label>Poll</mat-label>
                        <mat-select formControlName="pollId">
                            @if (!polls.length && selectedCommunityId) {
                                <mat-option disabled value="">No polls available
                                </mat-option>
                            }
                            @if (!!polls.length) {
                                <mat-option value="">All</mat-option>
                            }
                            @for (poll of polls; track poll) {
                                <mat-option [value]="poll.id">[ID: {{ poll.id }}] - {{ poll.text }}
                                </mat-option>
                            }
                        </mat-select>
                        @if (form.controls['pollId'].hasError('required')) {
                            <mat-error>
                                This field is required
                            </mat-error>
                        }
                    </mat-form-field>
                }
                @if (reportControlIds.includes('segmentId')) {
                    <mat-form-field class="w-100" color="accent">
                        <mat-label>Segment</mat-label>
                        <mat-select formControlName="segmentId">
                            @if (!segments.length && selectedCommunityId) {
                                <mat-option disabled value="">No segments
                                    available
                                </mat-option>
                            }
                            @if (!!segments.length) {
                                <mat-option value="">All</mat-option>
                            }
                            @for (segment of segments; track segment) {
                                <mat-option [value]="segment.id">{{ segment.name }}
                                </mat-option>
                            }
                        </mat-select>
                        @if (form.controls['segmentId'].hasError('required')) {
                            <mat-error>
                                This field is required
                            </mat-error>
                        }
                        @if (segmentLoading) {
                            <mat-icon matSuffix>
                                <mat-spinner color="accent"></mat-spinner>
                            </mat-icon>
                        }
                    </mat-form-field>
                }
                @if (reportControlIds.includes('activityType')) {
                    <mat-form-field class="w-100" color="accent">
                        <mat-label>Activity type</mat-label>
                        <mat-select formControlName="activityType">
                            <mat-option value="">All</mat-option>
                            @for (activityType of activityTypes; track activityType) {
                                <mat-option
                                        [value]="activityType.value">{{ activityType.label }}
                                </mat-option>
                            }
                        </mat-select>
                        @if (form.controls['activityType'].hasError('required')) {
                            <mat-error>
                                This field is required
                            </mat-error>
                        }
                    </mat-form-field>
                }
                @if (reportControlIds.includes('action')) {
                    <mat-form-field class="w-100" color="accent">
                        <mat-label>Action</mat-label>
                        <mat-select formControlName="action">
                            <mat-option value="">All</mat-option>
                            @for (action of actions; track action) {
                                <mat-option
                                        [value]="action">{{ action | removeKebabCase }}
                                </mat-option>
                            }
                        </mat-select>
                        @if (form.controls['action'].hasError('required')) {
                            <mat-error>
                                This field is required
                            </mat-error>
                        }
                    </mat-form-field>
                }
                @if (reportControlIds.includes('contentType')) {
                    <mat-form-field class="w-100" color="accent">
                        <mat-label>Content type</mat-label>
                        <mat-select formControlName="contentType">
                            <mat-option value="">All</mat-option>
                            @for (contentType of contentTypes; track contentType) {
                                <mat-option
                                        [value]="contentType.id">{{ contentType.name }}
                                </mat-option>
                            }
                        </mat-select>
                        @if (form.controls['contentType'].hasError('required')) {
                            <mat-error>
                                This field is required
                            </mat-error>
                        }
                    </mat-form-field>
                }
                @if (reportControlIds.includes('startDate') && reportControlIds.includes('endDate')) {
                    <mat-form-field
                            class="w-100"
                            color="accent">
                        <mat-label>Enter a date range</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input class="w-100" formControlName="startDate" matStartDate placeholder="Start date">
                            <input formControlName="endDate" matEndDate placeholder="End date">
                        </mat-date-range-input>
                        @if (dateSet) {
                            <mat-datepicker-toggle (click)="clearDate()" matIconSuffix>
                                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                            </mat-datepicker-toggle>
                        }
                        <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                        <mat-date-range-picker #picker color="accent"></mat-date-range-picker>
                        @if (form.controls['startDate'].hasError('matStartDateInvalid')) {
                            <mat-error>Invalid start date
                            </mat-error>
                        }
                        @if (form.controls['endDate'].hasError('matEndDateInvalid')) {
                            <mat-error>Invalid end date
                            </mat-error>
                        }
                        @if (form.controls['startDate'].hasError('required') || form.controls['endDate'].hasError('required')) {
                            <mat-error
                            >
                                This field is required
                            </mat-error>
                        }
                    </mat-form-field>
                }
            }
            @if (selectedManageMode === managementMode.Exist) {
                <mat-form-field class="w-100" color="accent">
                    <mat-label>Community</mat-label>
                    <mat-select [(ngModel)]="communitiesFilter"
                                (ngModelChange)="reloadContent(false)"
                                [ngModelOptions]="{standalone: true}">
                        <mat-option value="">All</mat-option>
                        @for (community of communities; track community) {
                            <mat-option [value]="community.id">{{ community.name }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <ng-container [ngTemplateOutlet]="statistics"></ng-container>
            }
            @if (selectedManageMode === managementMode.Pending) {
                @if (pendingReports.data.length <= 0) {
                    <p>There are no reports currently being generated</p>
                }
                @if (pendingReports.data.length > 0) {
                    <table [dataSource]="pendingReports" class="responsiveTable"
                           mat-table>
                        <ng-container matColumnDef="task_name">
                            <th *matHeaderCellDef mat-header-cell>Name</th>
                            <td *matCellDef="let row" mat-cell>
                                <b class="d-none columnTitle">Name:</b> {{ row.task_name }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="date_created">
                            <th *matHeaderCellDef mat-header-cell>Created At</th>
                            <td *matCellDef="let row" mat-cell><b class="d-none columnTitle">Created
                                At:</b> {{ row.date_created | date }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th *matHeaderCellDef mat-header-cell>Status</th>
                            <td *matCellDef="let row" mat-cell><b
                                    class="d-none columnTitle">Status:</b> {{ row.status }}
                            </td>
                        </ng-container>
                        <tr *matHeaderRowDef="displayColumns" mat-header-row></tr>
                        <tr *matRowDef="let row; columns: displayColumns;" mat-row></tr>
                        <tr *matNoDataRow class="mat-row">
                            <td class="mat-cell text-center"
                                colspan="3"> There are no reports currently being generated
                            </td>
                        </tr>
                    </table>
                }
            }
        </mat-card-content>

        <mat-card-footer>
            <mat-card-actions class="text-center mt-10">
                @if (allowLoadMore && selectedManageMode === managementMode.Exist) {
                    <button (click)="loadMore()"
                            class="mx-auto" color="accent" mat-raised-button>
                        Load more
                    </button>
                }
                @if (selectedManageMode == managementMode.Generate) {
                    <button (click)="generate()"
                            [disabled]="form.invalid || loading"
                            class="mx-auto"
                            color="accent" mat-flat-button>
                        Generate report
                        @if (loading) {
                            <mat-icon>
                                <mat-spinner color="accent"></mat-spinner>
                            </mat-icon>
                        }
                    </button>
                }
                @if (selectedManageMode == managementMode.BI) {
                    <button (click)="generate(true)"
                            [disabled]="form.invalid || loading"
                            class="mx-auto"
                            color="accent" mat-flat-button>
                        Generate Power Bi Url
                        @if (loading) {
                            <mat-icon>
                                <mat-spinner color="accent"></mat-spinner>
                            </mat-icon>
                        }
                    </button>
                }
            </mat-card-actions>
        </mat-card-footer>
    </mat-card>
</main>


<ng-template #statistics>
    <mat-accordion class="statistics-accordion">
        @for (statSet of filteredCombinedStatistics; track statSet) {
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ statSet.title }}
                    </mat-panel-title>
                    @if (statSet.community_id && getCommunityFromId(statSet.community_id) != '') {
                        @if (!statSet.title.includes(getCommunityFromId(statSet.community_id))) {
                            <mat-panel-description
                            >
                                For {{ getCommunityFromId(statSet.community_id) }}
                            </mat-panel-description>
                        }
                    }
                </mat-expansion-panel-header>
                @if (statSet.statistics) {
                    <div class="chart">
                        @for (stat of statSet.statistics; track stat) {
                            <div [class.py-15]="stat.skip" class="chart-bar">
                                <div class="chart-bar-total">
                                    <span class="z-index-2">{{ stat.total | number }}</span>
                                    @if (stat.new) {
                                        <div [style.width.%]="calculateNewPercentage(stat.new, stat.total)"
                                             class="chart-bar-new">
                                            +{{ stat.new | number }}
                                        </div>
                                    }
                                </div>
                                <div class="chart-bar-label">{{ stat.label }}</div>
                            </div>
                        }
                    </div>
                }
                @if (statSet.fileUrl) {
                    <div class="chart">
                        <div class="chart-bar">
                            <div class="chart-bar-label">
                                {{ statSet.title }} successfully generated. You can download it by clicking the button
                                below.
                            </div>
                        </div>
                    </div>
                }
                <div class="expansion-actions">
                    <!--                <div *ngIf="statSet.type === 'Engagement'"-->
                    <!--                     [matTooltipDisabled]="allowGeneratePowerBi(statSet) || powerBiTokens.has(statSet.id)"-->
                    <!--                     matTooltip="PowerBi token generation disabled for reports featuring all communities">-->
                    <!--                    <button-->
                    <!--                            (click)="generatePowerBi(statSet)"-->
                    <!--                            [disabled]="!allowGeneratePowerBi(statSet)"-->
                    <!--                            class=""-->
                    <!--                            color="accent"-->
                    <!--                            mat-raised-button>-->
                    <!--                        Generate PowerBi token-->
                    <!--                        <mat-icon *ngIf="loadingPowerBi">-->
                    <!--                            <mat-spinner color="accent"></mat-spinner>-->
                    <!--                        </mat-icon>-->
                    <!--                    </button>-->
                    <!--                </div>-->
                    @if (statSet.fileUrl) {
                        <div>
                            <button
                                    (click)="downloadFile(statSet)"
                                    class=""
                                    color="accent"
                                    mat-raised-button>
                                Download file
                                @if (loadingPowerBi) {
                                    <mat-icon>
                                        <mat-spinner color="accent"></mat-spinner>
                                    </mat-icon>
                                }
                            </button>
                        </div>
                    }
                </div>
                @if (powerBiTokens.has(statSet.id)) {
                    <div class="expansion-powerbi-info mt-20">
                        <small>The first report may some time to generate after creating a PowerBI URL</small>
                        <div class="flex-row gap-5 mb-10 align-items-center">
                            <div [style.flex]="2">Url:</div>
                            <mat-form-field [style.flex]="15" class="w-100 noBottomPadding">
                                <input #url [value]="powerBiTokens.get(statSet.id)?.url" matInput readonly>
                            </mat-form-field>
                            <button [cdkCopyToClipboard]="url.value" [style.flex]="1" mat-icon-button matTooltip="Copy">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                        </div>
                        <div class="flex-row gap-5 align-items-center">
                            <div [style.flex]="2">Token:</div>
                            <mat-form-field [style.flex]="15" class="w-100 noBottomPadding">
                                <input #token [value]="powerBiTokens.get(statSet.id)?.token" matInput readonly>
                            </mat-form-field>
                            <button [cdkCopyToClipboard]="token.value" [style.flex]="1" mat-icon-button
                                    matTooltip="Copy">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                        </div>
                        <div class="mt-20 flex-row align-items-center gap-25">
                            <mat-icon color="accent">priority_high</mat-icon>
                            {{ powerBiTokens.get(statSet.id)?.description }}
                        </div>
                    </div>
                }
            </mat-expansion-panel>
        }
    </mat-accordion>
</ng-template>
